//#region IMPORT
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import dayjs from 'dayjs';
import ExcelJS from 'exceljs';
/** Components */
import POL_BASIC_02 from './POL_BASIC_02';
import useDelete from '../../../../hooks/useDeleteN';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import useFileUpload from '../../../../hooks/useFileUpload';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import {
  useDelete1,
  useDelete2,
  useDelete3,
  useSave1,
  useSave2,
  useSave3,
  useSave4,
  useSave5,
  useSearch1,
  useSearch2,
  useSearch4,
} from './POL_BASIC_02_QUERY';
import { POL_BASIC_02_Schema } from './POL_BASIC_02_Schema';
import { createInitial } from '../../../../util';
import { v4 as uuidv4 } from 'uuid';

// 화면 MENU_ID
const SCREEN_MENU_ID = 'PolicyAndGoals';

function POL_BASIC_02F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);

  const [inputs, setInputs] = useState(() =>
    createInitial(POL_BASIC_02_Schema.fields.form)
  );

  const [fileModalToggle, setFileModalToggle] = useState(false);

  const [modalToggle1, setModalToggle1] = useState({
    codeManagement: false, // 코드관리 전체
    categoryDetail: false, // 카테고리 수정 또는 추가
    mode: 'ADD', // 카테고리 수정 또는 추가
    categoryTarget: null, // 편집중인 카테고리
  });

  const [categoryList, setCategoryList] = useState([]); // 전체 카테고리 리스트

  const gridRef1 = useRef(); //dtl 그리드
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);
  const fileInputRef = useRef(null); // 엑셀 업로드용 파일 input
  const chaebunRef = useRef(null); // 최신 chaebun 값을 저장하는 ref
  const gridOrderRef = useRef([]); // 저장 시 순서 반영용
  const orderChangedRef = useRef(false); // 드래그/엑셀 등 순서 변경 여부
  //#endregion

  //#region 커스텀훅
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.no,
    getKeyFromResult: (result) => result.no,
  });

  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (_item, custCd) => `PolicyAndGoals/${custCd}/POL_BASIC_02`,
  });
  //#endregion

  // 삭제
  const delete1 = useDelete1();
  const delete2 = useDelete2();
  const delete3 = useDelete3();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });
  // 초기 파일 정보 불러오기

  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef1.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef1.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    rowNode.setData(updatedRowData);

    if (!Array.isArray(changedRowData1)) return;

    const alreadyChangedIndex = changedRowData1.findIndex(
      (item) => item.no === updatedRowData.no
    );
    const newChangedList = [...changedRowData1];

    if (alreadyChangedIndex > -1) {
      newChangedList[alreadyChangedIndex] = updatedRowData;
    } else {
      newChangedList.push(updatedRowData);
    }
    setChangedRowData1(newChangedList);
  };

  useEffect(() => {
    if (props.searchClick2 || props.filterClick2) {
      // 회사/사업장 정보 체크
      if (!props.validateSelection()) {
        ResetLogic();
        props.setSearchClick2?.(false);
        props.setFilterClick2?.(false);
        return;
      }
      Search4();
      props.setSearchClick2?.(false);
      props.setFilterClick2?.(false);
    }
  }, [props.searchClick2, props.filterClick2]);

  const ResetLogic = () => {
    setInputs(createInitial(POL_BASIC_02_Schema.fields.form));

    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);

    setCategoryList([]);

    setModalToggle1({
      codeManagement: false,
      categoryDetail: false,
      mode: 'ADD',
      targetData: null,
    });

    chaebunRef.current = null;
    gridOrderRef.current = [];
    orderChangedRef.current = false;
    gridRef1?.current?.api?.deselectAll();
  };

  const AddClickLogic = (_gridRef) => {
    const api = _gridRef?.current?.api;
    if (!api) return;

    const selectedNodes = api.getSelectedNodes();
    const currentRows = [];
    api.forEachNode((node) => {
      if (node?.data) currentRows.push(node.data);
    });

    let addIndex = currentRows.length;
    if (selectedNodes.length > 0) {
      const lastSelected = selectedNodes[selectedNodes.length - 1];
      addIndex = (lastSelected.rowIndex ?? addIndex - 1) + 1;
    }

    const newRow = {
      ...createInitial(POL_BASIC_02_Schema.fields.grid),
      newYn: 'Y',
      no: uuidv4(),
      seq: '',
    };

    const nextRows = [...currentRows];
    nextRows.splice(addIndex, 0, newRow);

    // rowData와 그리드를 함께 맞춰, 리렌더 시 추가 행이 사라지거나 중복 쌓이지 않게 함
    setRowData1(nextRows);
    orderChangedRef.current = true;
    setChangedRowData1((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      if (list.some((row) => String(row?.no) === String(newRow.no))) {
        return list;
      }
      return [...list, newRow];
    });

    setTimeout(() => {
      if (!_gridRef?.current?.api) return;
      const firstEditableColumn = _gridRef.current.api
        .getColumnDefs()
        .find((col) => col.editable && !col.hide && col.field);
      if (!firstEditableColumn?.field) return;

      _gridRef.current.api.ensureIndexVisible(addIndex, 'middle');
      _gridRef.current.api.setFocusedCell(addIndex, firstEditableColumn.field);
      _gridRef.current.api.startEditingCell({
        rowIndex: addIndex,
        colKey: firstEditableColumn.field,
      });
    }, 0);
  };

  // 순서 저장용 행 목록 (백엔드 Dictionary 키 = gubun|gubun2)
  const BuildReorderRows = (rows = []) => {
    const order = [];
    const seen = new Set();

    (rows || []).forEach((row) => {
      if (!row || row.deleteYn === 'Y') return;

      const gubun = String(row.gubun ?? '').trim();
      const gubun2 = String(row.gubun2 ?? '').trim();
      // 둘 다 빈 값이면 Key: "|" 중복 오류 발생 → 제외
      if (!gubun && !gubun2) return;

      const key = `${gubun}|${gubun2}`;
      if (seen.has(key)) return;
      seen.add(key);

      order.push({
        gubun,
        gubun2,
        seq: row.seq || '',
      });
    });

    return order;
  };

  const HandleRowDragEnd = () => {
    const gridApi = gridRef1?.current?.api;
    if (!gridApi) return;

    // getRowId(no)를 유지한 채 표시 순서만 반영 (no 재부여 시 변경행 중복 저장 발생)
    const dragRowData = [];
    gridApi.forEachNode((node) => {
      if (node?.data) dragRowData.push({ ...node.data });
    });

    setRowData1(dragRowData);
    orderChangedRef.current = true;
    gridOrderRef.current = BuildReorderRows(dragRowData);
  };

  //#region 조회

  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      setInputs(rows[0]);
      chaebunRef.current = rows[0]?.chaebun;
      Search2({
        chaebun: rows[0]?.chaebun,
      });
    },
  });
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });

  const { refetch: Search4 } = useSearch4({
    onSuccess: async (rows) => {
      setCategoryList(rows ?? []);
      Search1();
    },
  });

  //#endregion
  //#region 저장
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save5Async } = useSave5();

  const CaptureGridOrder = () => {
    const rows = [];
    const gridApi = gridRef1?.current?.api;
    if (gridApi) {
      gridApi.forEachNode((node) => {
        if (node?.data) rows.push(node.data);
      });
    } else {
      (rowData1 || []).forEach((row) => rows.push(row));
    }
    return BuildReorderRows(rows);
  };

  const ReorderGridLogic = async (chaebun) => {
    const orderRows = gridOrderRef.current?.length
      ? gridOrderRef.current
      : CaptureGridOrder();

    if (!chaebun || orderRows.length === 0) return;

    const res = await Save5Async({
      rows: orderRows,
      chaebun,
    });

    const result = Array.isArray(res?.data) ? res.data[0] : res?.data || res;
    if (result?.isSuccess === false) {
      throw new Error(result?.message || '순서 저장에 실패했습니다.');
    }

    orderChangedRef.current = false;
    gridOrderRef.current = [];
  };

  const GetUniqueChangedRows = () => {
    const seen = new Set();
    // 실제 추가/수정 행만 저장 대상 — 드래그로 순만 바꾼 행은 제외(잘못된 insert 방지)
    return (changedRowData1 || []).filter((row) => {
      if (!row || row.deleteYn === 'Y') return false;
      if (row.newYn !== 'Y' && row.editYn !== 'Y') return false;
      const key = String(row.no ?? '');
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const { run: SaveLogic2 } = useSave({
    menuId: SCREEN_MENU_ID,
    schema: POL_BASIC_02_Schema,
    getChangedRows: () => GetUniqueChangedRows(),
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => {
      // chaebunRef에 최신 값이 있으면 사용, 없으면 inputs.chaebun 사용
      const currentChaebun = chaebunRef.current || inputs.chaebun || '';
      return Save2Async({
        rows,
        chaebun: currentChaebun,
      });
    },
    fileSave: async (rows) => {
      await SaveLogicFile(rows, searchInfo.custCd);
    },
    fileDelete: async (rows) => {
      await DeleteLogicFile(rows);
    },
    reset: ResetLogic,
    refresh: Search4,
    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search4,
      }),
    onSuccessRefresh: async ({ saveDetailData, changedRows }) => {
      const hasFailure = (saveDetailData ?? []).some(
        (r) => r.isSuccess === false
      );

      if (hasFailure) {
        await handlePartialRefresh({
          saveResult: saveDetailData,
          changedRows,
          searchLogic: Search4,
        });
        return;
      }

      const currentChaebun = chaebunRef.current || inputs.chaebun || '';
      // 순서 변경(추가 위치/드래그/엑셀)이 있을 때만 SEQ 재정렬
      if (currentChaebun && orderChangedRef.current) {
        await ReorderGridLogic(currentChaebun);
      }

      ResetLogic();
      await Search4();
    },
  });

  const GetDuplicateGubunPair = () => {
    const deletedNoSet = new Set(
      (deletedRowData1 || []).map((row) => String(row?.no ?? ''))
    );

    const activeRowMap = new Map();
    const gridApi = gridRef1?.current?.api;
    if (gridApi) {
      gridApi.forEachNode((node) => {
        const row = node?.data;
        if (!row) return;
        if (row?.deleteYn === 'Y') return;
        const rowNo = String(row?.no ?? '');
        if (deletedNoSet.has(rowNo)) return;
        if (!activeRowMap.has(rowNo)) {
          activeRowMap.set(rowNo, row);
        }
      });
    } else {
      (rowData1 || [])
        .filter((row) => !row?.deleteYn)
        .forEach((row) => {
          const rowNo = String(row?.no ?? '');
          if (deletedNoSet.has(rowNo)) return;
          if (!activeRowMap.has(rowNo)) {
            activeRowMap.set(rowNo, row);
          }
        });
    }

    const activeRows = Array.from(activeRowMap.values());
    const keyMap = new Map();
    for (const row of activeRows) {
      const gubun = String(row?.gubun ?? '').trim();
      const gubun2 = String(row?.gubun2 ?? '').trim();

      // 필수값 미입력 상태는 중복검사에서 제외
      if (!gubun || !gubun2) continue;

      const key = `${gubun}|${gubun2}`;

      if (!keyMap.has(key)) {
        keyMap.set(key, row);
        continue;
      }
      const firstRow = keyMap.get(key);
      return {
        isDuplicate: true,
        gubun,
        gubun2,
        firstNo: firstRow?.no,
        secondNo: row?.no,
      };
    }
    return { isDuplicate: false };
  };

  const SaveLogic1 = async () => {
    try {
      const duplicateInfo = GetDuplicateGubunPair();
      if (duplicateInfo?.isDuplicate) {
        dispatch(
          showSnackbar({
            message: `중복 데이터가 있습니다. [구분: ${duplicateInfo.gubun}, 세부목표: ${duplicateInfo.gubun2}] (중복된행번호: ${duplicateInfo.secondNo})`,
            type: 'warning',
          })
        );
        return;
      }

      const mstRes = await Save1Async([inputs]);
      const mstRows = Array.isArray(mstRes?.data) ? mstRes.data : [];
      const nextChaebun = mstRows?.[0]?.chaebun || inputs.chaebun || '';

      if (nextChaebun) {
        chaebunRef.current = nextChaebun;
        setInputs((prev) => ({ ...prev, chaebun: nextChaebun }));
      }

      const changedRows = GetUniqueChangedRows();
      const hasDtlWork = deletedRowData1.length > 0 || changedRows.length > 0;
      const shouldReorder =
        orderChangedRef.current && CaptureGridOrder().length > 0;

      if (shouldReorder) {
        gridOrderRef.current = CaptureGridOrder();
      }

      if (!hasDtlWork) {
        if (shouldReorder) {
          const currentChaebun =
            chaebunRef.current || inputs.chaebun || nextChaebun || '';
          if (!currentChaebun) {
            dispatch(
              showSnackbar({
                message: '순서 저장을 위해 먼저 조회 후 저장해 주세요.',
                type: 'warning',
              })
            );
            return;
          }
          await ReorderGridLogic(currentChaebun);
          await Search4();
        } else {
          await Search4();
        }
        return;
      }

      await SaveLogic2();
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  const { runAsync: Save3Async } = useSave3();
  const { runAsync: Save4Async } = useSave4();

  const { run: handleCodeManagementSave } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '사업장',
    schema: POL_BASIC_02_Schema,
    getChangedRows: () => {
      const cats = (categoryList || []).filter((c) => c.deleteYn !== 'Y');

      return cats.filter((cat) => {
        const hasCatChange = cat.newYn === 'Y' || cat.editYn === 'Y';

        const items = cat.items || [];
        const hasItemChange = items.some(
          (it) => it.deleteYn === 'Y' || it.newYn === 'Y' || it.editYn === 'Y'
        );

        return hasCatChange || hasItemChange;
      });
    },
    getDeletedRows: () => {
      const deletedCats = categoryList.filter((cat) => cat.deleteYn === 'Y');

      const deletedItems = categoryList
        .filter((cat) => cat.deleteYn !== 'Y')
        .flatMap((cat) =>
          (cat.items || []).filter((it) => it.deleteYn === 'Y')
        );

      return [
        ...deletedCats.map((c) => ({ ...c, _type: 'CATEGORY' })),
        ...deletedItems.map((i) => ({ ...i, _type: 'ITEM' })),
      ];
    },
    requestDelete: async (rows) => {
      if (!rows || rows.length === 0) return { isSuccess: true };

      const catDeletes = rows.filter(
        (r) => r._type === 'CATEGORY' && r.categoryId
      );
      const itemDeletes = rows.filter((r) => r._type === 'ITEM' && r.itemId);

      if (itemDeletes.length > 0) await delete3.runAsync(itemDeletes);
      if (catDeletes.length > 0) await delete2.runAsync(catDeletes);

      return { isSuccess: true };
    },
    requestSave: async (changedRows) => {
      const catResult = await Save3Async(changedRows);
      const savedCatRows = Array.isArray(catResult?.data) ? catResult.data : [];

      const itemRows = [];

      (changedRows || []).forEach((cat, idx) => {
        const newId =
          savedCatRows[idx]?.data?.[0]?.CategoryId ??
          savedCatRows[idx]?.data?.[0]?.categoryId;

        const savedCatId = Number(newId || cat.categoryId || 0);

        (cat.items || [])
          .filter((it) => it.deleteYn !== 'Y')
          .forEach((it, itemIdx) => {
            itemRows.push({
              ...it,
              categoryId: savedCatId,
              sortOrder: it.sortOrder ?? itemIdx + 1,
            });
          });
      });

      if (itemRows.length > 0) {
        const itemResult = await Save4Async(itemRows);
        const savedItemRows = Array.isArray(itemResult?.data)
          ? itemResult.data
          : [];
        return { data: [...savedCatRows, ...savedItemRows] };
      }

      return { data: savedCatRows };
    },
    refresh: Search4,
    reset: () => {
      setModalToggle1((prev) => ({ ...prev, codeManagement: false }));
    },
  });
  //#endregion
  //#region 나머지 함수

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  // 파일 업로드 팝업 열기
  const PopupFileClickEvent = async (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '행 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    setSelectedRowData1([rowData]);
    try {
      const api = gridRef1.current?.api;
      if (api) {
        api.deselectAll();
        api.forEachNode((n) => {
          if (n.data?.no === rowData.no) n.setSelected(true);
        });
      }
    } catch {}

    const filePath = rowData.previewFilePath || rowData.filePath || '';
    const fileName =
      rowData.fileName || (filePath ? filePath.split('/').pop() : '');
    const normalized = filePath.startsWith('http')
      ? filePath.replace(Global.file.useUrl + 'files/', '')
      : filePath;
    const previewUrl = filePath
      ? filePath.startsWith('http')
        ? filePath
        : (() => {
            const safeDecode = (value, max = 2) => {
              let out = String(value || '');
              for (let i = 0; i < max; i++) {
                try {
                  const dec = decodeURIComponent(out);
                  if (dec === out) break;
                  out = dec;
                } catch {
                  break;
                }
              }
              return out;
            };
            const parts = String(normalized).split('/');
            const last = parts.pop() || '';
            const encodedLast = encodeURIComponent(safeDecode(last));
            return (
              Global.file.useUrl + 'files/' + [...parts, encodedLast].join('/')
            );
          })()
      : '';

    dispatch(
      setFileFields({
        previewFilePathField: 'previewFilePath',
        previewFileName: fileName || '파일 선택',
        previewUrl,
      })
    );

    setTimeout(() => setFileModalToggle(true), 100);
  };
  const handleCodeManagementClick = async () => {
    if (!props.validateSelection()) {
      dispatch(
        showSnackbar({
          message: '사업장을 선택해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    const custCd = searchInfo.custCd;
    if (!custCd) {
      dispatch(
        showSnackbar({
          message: '사업장을 선택해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    setModalToggle1((prev) => ({
      ...prev,
      codeManagement: true,
    }));
  };

  const handleCategorySave = (targetName) => {
    const nameToSave =
      targetName || modalToggle1.categoryTarget?.categoryName || '';

    if (!nameToSave.trim()) {
      dispatch(
        showSnackbar({ message: '구분명을 입력하세요.', type: 'warning' })
      );
      return;
    }

    if (modalToggle1.mode === 'EDIT') {
      setCategoryList((prev) =>
        prev.map((item) =>
          item.categoryId === modalToggle1.categoryTarget.categoryId
            ? {
                ...item,
                categoryName: nameToSave.trim(),
                editYn: 'Y',
              }
            : item
        )
      );
    } else {
      const newCategory = {
        categoryId: 0,
        _tempId: `tmp_${Date.now()}`,
        categoryName: nameToSave.trim(),
        sortOrder: String((categoryList?.length || 0) + 1),
        items: [],
        custCd: searchInfo.custCd,
        year: new Date().getFullYear().toString(),
        newYn: 'Y',
      };
      setCategoryList((prev) => [...prev, newCategory]);
    }

    setModalToggle1((prev) => ({
      ...prev,
      categoryDetail: false,
      categoryTarget: null,
    }));
  };

  // 삭제 버튼 클릭 시: 선택된 행을 "삭제 예정" 상태로 마킹 (실제 삭제는 저장 시 수행)
  const DeleteLogic1 = () => {
    const api = gridRef1.current?.api;
    const selected = api?.getSelectedRows?.() || [];
    deleteHandler1.MarkedForDeletion(selected);
  };

  //#endregion

  //인쇄 함수
  const PrintLogic1 = async () => {
    dispatch(showLoading());
    let headerData = {};
    let tableData = [];
    try {
      let today = new Date();
      let year = today.getFullYear(); // 년도
      let month = String(today.getMonth() + 1).padStart(2, '0'); // 월
      let date = String(today.getDate()).padStart(2, '0'); // 날짜

      const titleYear = searchInfo?.year || dayjs().format('YYYY');
      const titleText = `${titleYear}년도 안전보건목표/세부추진계획`;

      headerData = {
        ...inputs,
        today: year + '년 ' + month + '월 ' + date + '일',
        titleYear,
        titleText,
      };

      tableData = rowData1;

      const printData = {
        FileName: 'POL_BASIC_02',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };
  const DownloadLogic1 = async () => {
    const row = selectedRowData1?.[0];

    if (row?.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    const rawPath = row?.filePath || row?.previewFilePath || '';

    if (!rawPath) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = Commons.EncodeUrl(rawPath);
      const fileName = row?.fileName || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 엑셀 (안전보건활동목표 및 세부추진계획) 업로드
  const ExcelUpload1 = async (file) => {
    try {
      dispatch(showLoading());

      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      // B4 셀에서 전사목표 읽기
      const cellGoal = worksheet.getCell('B4');
      const goalValue = cellGoal.value?.toString().trim() || '';
      if (goalValue) {
        setInputs((prev) => ({
          ...prev,
          goal: goalValue,
        }));
      }

      // 7행부터 데이터 읽기
      const startRow = 7;
      const columnKeys = [
        'gubun',
        'gubun2',
        'planQuarter1',
        'performanceQuarter1',
        'planQuarter2',
        'performanceQuarter2',
        'planQuarter3',
        'performanceQuarter3',
        'planQuarter4',
        'performanceQuarter4',
        'target',
        'department',
        'percent',
        'performance',
        'remark',
      ];

      const uploadedData = [];
      let currentRow = startRow;
      let hasData = true;

      while (hasData) {
        const row = worksheet.getRow(currentRow);
        const rowData = {};

        // 첫 번째 컬럼이 비어있으면 데이터가 없는 것으로 간주
        const firstCellValue = row.getCell(1).value;
        if (!firstCellValue || firstCellValue.toString().trim() === '') {
          hasData = false;
          break;
        }

        columnKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          let value = cell.value;

          // 값이 없으면 빈 문자열
          if (value === null || value === undefined) {
            value = '';
          } else {
            // 객체인 경우 문자열로 변환
            if (typeof value === 'object' && value !== null) {
              value =
                Array.isArray(value.richText) && value.richText.length > 0
                  ? value.richText.map((item) => item?.text || '').join('')
                  : value.toString().trim();
            } else {
              value = value.toString().trim();
            }
          }

          // 분기 계획/실적은 O(또는 Y/✓)를 Y로 변환
          if (
            key.includes('planQuarter') ||
            key.includes('performanceQuarter')
          ) {
            const normalized = String(value ?? '').trim().toUpperCase();
            value =
              normalized === 'O' ||
              normalized === 'Y' ||
              normalized === '✓'
                ? 'Y'
                : 'N';
          }

          // 달성률은 숫자로 변환
          if (key === 'percent') {
            value = value ? Number(value) || '' : '';
          }

          rowData[key] = value;
        });

        // 최소한 하나의 필드라도 값이 있으면 추가
        const hasAnyValue = Object.values(rowData).some(
          (v) => v !== '' && v !== null && v !== undefined
        );

        if (hasAnyValue) {
          // 신규 행으로 표시
          rowData.newYn = 'Y';
          rowData.no = `new_${Date.now()}_${currentRow}`;
          uploadedData.push(rowData);
        }

        currentRow++;
        // 최대 1000행까지만 읽기 (무한 루프 방지)
        if (currentRow > startRow + 1000) {
          break;
        }
      }

      if (uploadedData.length === 0) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoading());
        return;
      }

      // 키값 생성 함수 (gubun, gubun2 조합)
      const makeKeyString = (item) => {
        const gubun =
          item.gubun !== null && item.gubun !== undefined
            ? String(item.gubun).trim()
            : '';
        const gubun2 =
          item.gubun2 !== null && item.gubun2 !== undefined
            ? String(item.gubun2).trim()
            : '';
        return `${gubun}|${gubun2}`;
      };

      // 기존 데이터를 Map으로 변환 (키: gubun|gubun2, 값: 기존 행 데이터)
      const existingDataMap = new Map();
      rowData1.forEach((row) => {
        const key = makeKeyString(row);
        if (key && key !== '|') {
          // 빈 키는 제외
          existingDataMap.set(key, row);
        }
      });

      // 엑셀 데이터의 키 Set 생성 (삭제 대상 찾기용)
      const excelKeySet = new Set();
      uploadedData.forEach((row) => {
        const key = makeKeyString(row);
        if (key && key !== '|') {
          excelKeySet.add(key);
        }
      });

      // 데이터 변경 여부 확인 함수
      const hasChanges = (existingRow, excelRow) => {
        // 비교할 필드 목록
        const fieldsToCompare = [
          'planQuarter1',
          'performanceQuarter1',
          'planQuarter2',
          'performanceQuarter2',
          'planQuarter3',
          'performanceQuarter3',
          'planQuarter4',
          'performanceQuarter4',
          'target',
          'department',
          'percent',
          'performance',
          'remark',
        ];

        for (const field of fieldsToCompare) {
          const existingValue =
            existingRow[field] !== null && existingRow[field] !== undefined
              ? String(existingRow[field]).trim()
              : '';
          const excelValue =
            excelRow[field] !== null && excelRow[field] !== undefined
              ? String(excelRow[field]).trim()
              : '';

          // 숫자 필드는 숫자로 비교
          if (field === 'percent') {
            const existingNum = existingValue ? Number(existingValue) : null;
            const excelNum = excelValue ? Number(excelValue) : null;
            if (existingNum !== excelNum) {
              return true; // 변경사항 있음
            }
          } else {
            // 문자열 필드는 문자열로 비교
            if (existingValue !== excelValue) {
              return true; // 변경사항 있음
            }
          }
        }

        return false; // 변경사항 없음
      };

      const newRows = []; // 신규 추가할 행
      const updatedRows = []; // 기존 데이터 업데이트할 행
      const updatedKeys = new Set(); // 이미 업데이트 처리된 키 (중복 처리 방지)

      // 엑셀 데이터 처리
      for (const excelRow of uploadedData) {
        const key = makeKeyString(excelRow);

        // 키값이 비어있으면 건너뛰기
        if (!key || key === '|') {
          continue;
        }

        if (existingDataMap.has(key)) {
          // 키값이 기존 데이터에 있는 경우
          const existingRow = existingDataMap.get(key);

          // 변경사항이 있는지 확인
          if (hasChanges(existingRow, excelRow)) {
            // 변경사항이 있으면 업데이트
            const updatedRow = {
              ...existingRow,
              ...excelRow,
              newYn: existingRow.newYn || 'N', // 기존 데이터는 newYn 유지
              editYn: 'Y', // 수정 표시
              no: existingRow.no, // 기존 no 유지
              chaebun: existingRow.chaebun || '', // 기존 chaebun 유지
              seq: existingRow.seq || '', // 기존 seq 유지
            };
            updatedRows.push(updatedRow);
            updatedKeys.add(key);
          }
          // 변경사항이 없으면 업데이트하지 않음 (건너뛰기)
        } else {
          // 키값이 없으면 신규 추가
          newRows.push({
            ...excelRow,
            newYn: 'Y', // 신규 데이터 플래그
            no: `new_${Date.now()}_${Math.random()}`, // 고유한 no 생성
          });
        }
      }

      // 기존 데이터 중 엑셀에 없는 데이터는 삭제 대상으로 표시
      const rowsToDelete = [];
      rowData1.forEach((row) => {
        const key = makeKeyString(row);
        // 기존 데이터의 키가 엑셀에 없고, 이미 삭제 표시되지 않은 경우
        if (
          key &&
          key !== '|' &&
          !excelKeySet.has(key) &&
          row.deleteYn !== 'Y'
        ) {
          rowsToDelete.push({
            ...row,
            deleteYn: 'Y',
          });
        }
      });

      const updatedRowMap = new Map();
      updatedRows.forEach((row) => {
        updatedRowMap.set(makeKeyString(row), row);
      });
      const newRowMap = new Map();
      newRows.forEach((row) => {
        newRowMap.set(makeKeyString(row), row);
      });
      const deleteNoSet = new Set(rowsToDelete.map((row) => row.no));

      // 엑셀 행 순서를 그대로 유지하여 그리드에 반영
      const finalRowData = [];
      for (const excelRow of uploadedData) {
        const key = makeKeyString(excelRow);
        if (!key || key === '|') continue;

        if (updatedRowMap.has(key)) {
          finalRowData.push(updatedRowMap.get(key));
        } else if (newRowMap.has(key)) {
          finalRowData.push(newRowMap.get(key));
        } else if (existingDataMap.has(key)) {
          const existingRow = existingDataMap.get(key);
          if (!deleteNoSet.has(existingRow.no)) {
            finalRowData.push(existingRow);
          }
        }
      }

      gridRef1.current.api.setRowData(finalRowData);
      setRowData1(finalRowData);
      orderChangedRef.current = true;
      gridOrderRef.current = finalRowData
        .filter((row) => row?.deleteYn !== 'Y')
        .map((row) => ({
          gubun: row.gubun || '',
          gubun2: row.gubun2 || '',
        }));

      // 변경된 데이터 설정 (업데이트된 행 + 신규 행)
      const changedData = [...updatedRows, ...newRows];
      setChangedRowData1(changedData);

      // 삭제된 데이터 설정
      if (rowsToDelete.length > 0) {
        setDeletedRowData1((prev) => {
          const existingDeleted = prev || [];
          const newDeleted = rowsToDelete.filter(
            (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
          );
          return [...existingDeleted, ...newDeleted];
        });
      }

      dispatch(
        showSnackbar({
          message: '엑셀 업로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel upload error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
    }
  };

  // 엑셀 (안전보건활동목표 및 세부추진계획) 다운로드
  const ExcelDownload1 = async (headerData, detailData) => {
    const workbook = new ExcelJS.Workbook();
    const templateUrl = getTemplatePath();

    const response = await fetch(templateUrl);
    const arrayBuffer = await response.arrayBuffer();
    await workbook.xlsx.load(arrayBuffer);

    const worksheet = workbook.worksheets[0];
    if (!worksheet) {
      dispatch(
        showSnackbar({
          message: '템플릿 시트를 불러오지 못했습니다.',
          type: 'warning',
        })
      );

      return false;
    }

    // 상단 타이틀(연도 포함) 입력
    const titleYear = searchInfo?.year || dayjs().format('YYYY');
    const titleText = `${titleYear}년도 안전보건목표/세부추진계획`;
    let titleApplied = false;
    for (let r = 1; r <= 4 && !titleApplied; r += 1) {
      for (let c = 1; c <= 20 && !titleApplied; c += 1) {
        const cell = worksheet.getRow(r).getCell(c);
        const raw = cell?.value == null ? '' : String(cell.value);
        if (raw.includes('안전보건목표') && raw.includes('세부추진계획')) {
          setPreserveStyle(cell, titleText);
          titleApplied = true;
        }
      }
    }
    // 템플릿의 타이틀 셀 탐색에 실패한 경우를 대비한 fallback
    if (!titleApplied) {
      try {
        setPreserveStyle(worksheet.getCell('B2'), titleText);
      } catch (e) {
        // ignore
      }
    }

    // 평가정보 입력
    // 📌 전사 목표 (왼쪽 정렬)
    const cellGoal = worksheet.getCell('B4');
    const goalText = headerData?.goal || '';
    setPreserveStyle(cellGoal, goalText);
    cellGoal.alignment = {
      ...cellGoal.alignment,
      horizontal: 'left',
      vertical: 'middle',
    };

    // 데이터 삽입
    const startRow = 7;
    const columnKeys = [
      'gubun',
      'gubun2',
      'planQuarter1',
      'performanceQuarter1',
      'planQuarter2',
      'performanceQuarter2',
      'planQuarter3',
      'performanceQuarter3',
      'planQuarter4',
      'performanceQuarter4',
      'target',
      'department',
      'percent',
      'performance',
      'remark',
    ];

    detailData.forEach((item, index) => {
      const row = worksheet.getRow(startRow + index);
      columnKeys.forEach((key, i) => {
        const cell = row.getCell(i + 1);

        let value = item[key];
        // 분기 계획/실적은 Y/N을 O 표시로 변환
        if (key.includes('planQuarter') || key.includes('performanceQuarter')) {
          value = value === 'Y' ? 'O' : '';
        }
        // 달성률은 숫자로 표시
        if (key === 'percent') {
          value = value ? Number(value) : '';
        }

        // 값 설정 및 기존 스타일 유지
        setPreserveStyle(cell, value);

        // 스타일 덮어쓰기: 글꼴, 정렬, 줄바꿈, 테두리
        // ColumnDefs의 정렬 설정에 따라 정렬 적용
        cell.font = { name: 'Arial', size: 10 };
        let horizontalAlign = 'left';
        if (key.includes('planQuarter') || key.includes('performanceQuarter')) {
          horizontalAlign = 'center';
        } else if (key === 'percent') {
          horizontalAlign = 'right';
        }
        cell.alignment = {
          vertical: 'middle',
          horizontal: horizontalAlign,
          wrapText: false,
        };
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF808080' } },
          left: { style: 'thin', color: { argb: 'FF808080' } },
          bottom: { style: 'thin', color: { argb: 'FF808080' } },
          right: { style: 'thin', color: { argb: 'FF808080' } },
        };
      });
      row.commit();
    });

    // 분기 계획/실적 컬럼에 드롭다운 추가 (C~J열, 7행부터 충분한 행 수까지)
    // 데이터가 없는 행에도 드롭다운이 적용되도록 충분한 범위 설정 (200행까지)
    const maxDataRow = Math.max(startRow + detailData.length, startRow + 200);
    const endRow = maxDataRow;
    const quarterColumns = ['C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    quarterColumns.forEach((col) => {
      worksheet.dataValidations.add(`${col}${startRow}:${col}${endRow}`, {
        type: 'list',
        allowBlank: true,
        formulae: ['"O,"'], // O 또는 빈값 선택 가능
        showErrorMessage: true,
        errorStyle: 'error',
        errorTitle: '입력 오류',
        error: 'O 또는 빈값만 입력 가능합니다.',
      });
    });

    // 파일명 만들기
    const dateTimeStr = getCurrentFormattedDateTime('file');
    const methodName = `안전보건목표_및_세부추진계획_${dateTimeStr}.xlsx`;

    // 다운로드
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = methodName;
    link.click();
  };

  // 스타일 유지하며 값만 교체
  function setPreserveStyle(cell, value) {
    if (!cell) return;
    const { font, alignment, border, fill, numFmt } = cell;
    cell.value = value;
    cell.style = { font, alignment, border, fill, numFmt };
  }

  // 템플릿 경로 가져오기
  function getTemplatePath() {
    const base = `${Global.file.useUrl}files/ExcellExportFrom/PolicyAndGoals/`;
    return base + '안전보건활동목표_및_세부추진계획.xlsx';
  }

  // 현재 날짜와 시간을 'YYYY-MM-DD HH:mm:ss' 형식으로 반환하는 함수
  // Parameter: _type( { data: 'YYYY-MM-DD HH:mm:ss' } , { file: 'YYYYMMDD_HHmmss' })
  function getCurrentFormattedDateTime(_type) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    if (_type === 'data') {
      // 'YYYY-MM-DD HH:mm:ss' 형식
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else if (_type === 'file') {
      // 'YYYYMMDD_HHmmss' 형식
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    } else {
      // 기본값: data 형식
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }

  return (
    <div className="wrap">
      <POL_BASIC_02
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRowData1}
        setDeletedRowData1={setDeletedRowData1}
        fileModalToggle={fileModalToggle}
        setFileModalToggle={setFileModalToggle}
        inputs={inputs}
        setinputs={setInputs}
        gridRef1={gridRef1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        fileInputRef={fileInputRef}
        filterClick2={props.filterClick2}
        setFilterClick2={props.setFilterClick2}
        searchClick2={props.searchClick2}
        setSearchClick2={props.setSearchClick2}
        addClick2={props.addClick2}
        setAddClick2={props.setAddClick2}
        saveClick2={props.saveClick2}
        setSaveClick2={props.setSaveClick2}
        deleteClick2={props.deleteClick2}
        setDeleteClick2={props.setDeleteClick2}
        printClick2={props.printClick2}
        setPrintClick2={props.setPrintClick2}
        listClick2={props.listClick2}
        setListClick2={props.setListClick2}
        snackbar={props.snackbar}
        setSnackbar={props.setSnackbar}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        categoryList={categoryList}
        setCategoryList={setCategoryList}
        SaveLogic5={handleCodeManagementSave}
        handleCategorySave={handleCategorySave}
        // 함수
        validateSelection={props.validateSelection}
        SearchLogic1={Search4}
        SaveLogic1={SaveLogic1}
        DeleteLogic1={DeleteLogic1}
        PrintLogic1={PrintLogic1}
        DownloadLogic1={DownloadLogic1}
        ExcelUpload1={ExcelUpload1}
        ExcelDownload1={ExcelDownload1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 파일 업로드/미리보기 (useFileUpload 기반)
        PopupFileClickEvent={PopupFileClickEvent}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection={handleRowSelection}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        updateCurrentRowData={updateCurrentRowData}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        handleCodeManagementClick={handleCodeManagementClick}
        SaveLogicPreview={SaveLogicPreview}
        AddClickLogic={AddClickLogic}
        HandleRowDragEnd={HandleRowDragEnd}
      />
    </div>
  );
}

export default POL_BASIC_02F;
